import { useQuery } from '@tanstack/react-query';
import { QueryKey } from 'src/query-client';
import { IFetchPageQuery } from '../IFetchQueryOptions';
import { fetchCaisoResourceBids, fetchCaisoResources } from '.';

export const useScResourceBidsQuery = (query: IFetchPageQuery, _options = {}) => {
    return useQuery({
        queryKey: [QueryKey.SC_RESOURCE_BIDS],
        queryFn: () => fetchCaisoResourceBids(query),
    });
};

export const useScResourcesListQuery = (query: IFetchPageQuery, _options = {}) => {
    return useQuery({
        queryKey: [QueryKey.SC_RESOURCES],
        queryFn: () => fetchCaisoResources(query),
        ..._options,
    });
};
